/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgPause = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={13}
    height={16}
    viewBox='0 0 13 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 1.30544C0 0.584465 0.584465 0 1.30544 0H4.65272C5.37369 0 5.95816 0.584465 5.95816 1.30544V14.6946C5.95816 15.4155 5.37369 16 4.65272 16H1.30544C0.584465 16 0 15.4155 0 14.6946V1.30544ZM2.61088 2.61088V13.3891H3.34728V2.61088H2.61088Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.69456 1.30544C6.69456 0.584465 7.27903 0 8 0H11.3473C12.0683 0 12.6527 0.584465 12.6527 1.30544V14.6946C12.6527 15.4155 12.0683 16 11.3473 16H8C7.27903 16 6.69456 15.4155 6.69456 14.6946V1.30544ZM9.30544 2.61088V13.3891H10.0418V2.61088H9.30544Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgPause
